import React from 'react';
import AutoSaveIndicator from '../../../../composants/AutoSaveIndicator/AutoSaveIndicator';
import type { AutoSaveStatus } from '../../../../hooks/useAutoSave';

// ── Types ─────────────────────────────────────────────────────────────────────

export type SaveFeedback = { ok: boolean; msg: string } | null;

export const CRITERES_TECHNIQUES = [
  { slug: 'description_technique', intitule: 'Réponse technique au besoin', max: 3000, points: null as number | null },
  { slug: 'description_humain', intitule: 'Présentation des moyens humains et matériels dédiés à la consultation (sur 5 points)', max: 3000, points: null as number | null },
  { slug: 'description_operationnel', intitule: 'Présentation des modes opératoires dédiés à la consultation (sur 4 points)', max: 3000, points: null as number | null },
  { slug: 'description_environnement', intitule: 'Présentation des mesures en matière environnementale et sociale dédiés à la consultation (sur 1 point)', max: 3000, points: null as number | null },
] as const;

// ── Props ─────────────────────────────────────────────────────────────────────

interface SectionOffreTechniqueProps {
  poidsOffreTechnique: number;
  canEdit: boolean;
  offreTechnique: Record<string, string>;
  onChangeCritere: (slug: string, value: string) => void;
  autoSaveStatus: AutoSaveStatus;
  autoSaveError: string | null;
}

// ── Section "Offre technique" ─────────────────────────────────────────────────

const SectionOffreTechnique: React.FC<SectionOffreTechniqueProps> = ({
  poidsOffreTechnique,
  canEdit,
  offreTechnique,
  onChangeCritere,
  autoSaveStatus,
  autoSaveError,
}) => {
  return (
    <>
      <div className="section-header">
        Offre technique (pondérée à {poidsOffreTechnique}%)
      </div>

      <div className="section-content">
        {CRITERES_TECHNIQUES.map((critere, index) => (
          <div key={critere.slug} className="critere-block">
            <label className="critere-label">
              {critere.intitule}
              {critere.points != null && ` (sur ${critere.points} points)`}
            </label>
            <textarea
              className={`critere-textarea${!canEdit ? ' critere-textarea-disabled' : ''}`}
              value={offreTechnique[critere.slug] ?? ''}
              onChange={(e) => onChangeCritere(critere.slug, e.target.value)}
              disabled={!canEdit}
              rows={index === 0 ? 10 : 6}
              maxLength={critere.max}
              placeholder="Votre réponse..."
            />
            <span className="char-counter">
              {(offreTechnique[critere.slug] ?? '').length} / {critere.max.toLocaleString('fr-FR')}
            </span>
          </div>
        ))}

        {/* Indicateur auto-save (Story 13.3) */}
        <div style={{ borderTop: '1px solid #e5e7eb', marginTop: '0.5rem', paddingTop: '0.5rem' }}>
          <AutoSaveIndicator status={autoSaveStatus} error={autoSaveError} />
        </div>
      </div>
    </>
  );
};

export default SectionOffreTechnique;
